import { render, staticRenderFns } from "./addingToBag.vue?vue&type=template&id=d4734cda&scoped=true"
import script from "./addingToBag.vue?vue&type=script&lang=js"
export * from "./addingToBag.vue?vue&type=script&lang=js"
import style0 from "./addingToBag.vue?vue&type=style&index=0&id=d4734cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4734cda",
  null
  
)

export default component.exports